// extracted by mini-css-extract-plugin
module.exports = {"icon":"_1RfcN_uYLJ3cy9I99krenv"};